<template>
  <v-container class="progress-goalSetting-smoking pt-0 border">
    <v-row>
      <v-col class="pt-6 pl-10">
        <h3>{{ $t("questionnaires.INFORMATION_PREFERENCES.topic.HOW_QUIT_SMOKING", "questionnaires") }}</h3>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pt-6 pl-10">
        <ol v-if="quitSmokingDocuments">
          <li v-for="document in quitSmokingDocuments" v-bind:key="document.id">
            <div class="pl-2 font-weight-bold">{{ document.title }}</div>
            <div class="pl-2 pb-4">{{ document.parts[0].text }}</div>
          </li>
        </ol>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PatientOverviewSmokingGoalSetting",
  data: function () {
    return {
      quitSmokingDocuments: null,
    }
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loadQuitSmokingContent();
    },
    async loadQuitSmokingContent() {
      this.quitSmokingDocuments = await this.$app.contentManager.getDocuments(['STEPS_TO_GIVE_UP_SMOKING'])
    }
  },
}
</script>
